// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"StatusIndicator_tooltip__g_9As","tooltipText":"StatusIndicator_tooltipText__Hho_T"};